<template>
  <div>
    <p class="error">{{ error }}</p>
    <p class="error" v-if="noFrontCamera">
      {{ $t('qr_code_reader.no_front_camera') }}
    </p>

    <p class="error" v-if="noRearCamera">
      {{ $t('qr_code_reader.no_rear_camera') }}
    </p>
    <qrcode-stream :track="paintBoundingBox" @decode="onDecode" @init="onInit">
      <button type="button" @click="switchCamera">
        {{ $t('qr_code_reader.change_camera') }}
      </button>
    </qrcode-stream>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader';

export default {
  components: { QrcodeStream },

  data() {
    return {
      error: '',
      camera: 'rear',
      noRearCamera: false,
      noFrontCamera: false,

      lastDetected: null, // { rawValue, boundingBox, ts }
      holdMs: 3000, // optional: keep box for 3s after last detection
    };
  },

  methods: {
    onDecode(result) {
      this.$emit('data', result);
    },
    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = this.$t('qr_code_reader.error_permission');
        } else if (error.name === 'NotFoundError') {
          this.error = this.$t('qr_code_reader.error_no_camera');
        } else if (error.name === 'NotSupportedError') {
          this.error = this.$t('qr_code_reader.error_secure_context');
        } else if (error.name === 'NotReadableError') {
          this.error = this.$t('qr_code_reader.error_in_use');
        } else if (error.name === 'OverconstrainedError') {
          this.error = this.$t('qr_code_reader.error_unsuitable');
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = this.$t('qr_code_reader.error_stream_api');
        } else if (error.name === 'InsecureContextError') {
          this.error = this.$t('qr_code_reader.error_secure_context_detail');
        } else {
          this.error = this.$t('qr_code_reader.error_generic', {
            errorName: error.name,
          });
        }
        const triedFrontCamera = this.camera === 'front';
        const triedRearCamera = this.camera === 'rear';

        const cameraMissingError = error.name === 'OverconstrainedError';

        if (triedRearCamera && cameraMissingError) {
          this.noRearCamera = true;
        }

        if (triedFrontCamera && cameraMissingError) {
          this.noFrontCamera = true;
        }

        console.error(error);
      }
    },

    paintBoundingBox(detectedCodes, ctx) {
      const now = Date.now();

      if (detectedCodes && detectedCodes.length) {
        const best = detectedCodes.reduce((a, b) => {
          const areaA = a.boundingBox.width * a.boundingBox.height;
          const areaB = b.boundingBox.width * b.boundingBox.height;
          return areaB > areaA ? b : a;
        });

        this.lastDetected = {
          rawValue: best.rawValue,
          boundingBox: best.boundingBox,
          ts: now,
        };
      }

      const toDraw =
        this.lastDetected &&
        (now - this.lastDetected.ts <= this.holdMs || this.holdMs === 0)
          ? [this.lastDetected]
          : [];

      if (!toDraw.length && this.lastDetected) {
        this.lastDetected = null;
        return;
      }

      if (toDraw.length) {
        toDraw.forEach(({ boundingBox }) => {
          const { x, y, width, height } = boundingBox;
          ctx.lineWidth = 3;
          ctx.strokeStyle = '#007bff';
          ctx.strokeRect(x, y, width, height);
        });
      }
    },

    switchCamera() {
      switch (this.camera) {
        case 'front':
          this.camera = 'rear';
          break;
        case 'rear':
          this.camera = 'front';
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style scoped>
.error {
  font-weight: bold;
  color: red;
}
</style>
